/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Create_OrderInputs */

const vi_dashboard_create_order = /** @type {(inputs: Dashboard_Create_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo đơn hàng`)
};

/**

* @param {Dashboard_Create_OrderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_create_order = /** @type {((inputs?: Dashboard_Create_OrderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Create_OrderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_create_order(inputs)
});